export default __webpack_public_path__ + "static/media/img-3.2b4d6f1e.jpg";